import _ from 'lodash'

import api from '@/api'
import constants from '@/constants'

import types from './challengeTypes.js'

export default {
  setChallenge(context, challenge) {
    context.commit(types.SET_CHALLENGE, {
      challenge: challenge,
    })

    const rewards = challenge.rewards.map(reward => {
      return {
        positon: reward.position,
        name: reward.name,
        mediaId: reward.photo._id,
        path: reward.photo.path,
      }
    })

    context.commit(types.SET_REWARDS, {
      rewards: rewards,
    })
  },

  setChallengeField(context, payload) {
    context.commit(types.SET_CHALLENGE_FIELD, {
      field: payload.field,
      value: payload.value,
    })
  },

  setReward(context, payload) {
    context.commit(types.SET_REWARD, {
      index: payload.index,
      reward: payload.reward,
    })
  },

  updateChallengeReward(context, payload) {
    context.commit(types.UPDATE_CHALLENGE_REWARD, {
      index: payload.index,
      field: payload.field,
      value: payload.value,
    })
  },

  clearChallenge(context) {
    context.commit(types.CLEAR_CHALLENGE)
    context.commit(types.CLEAR_CHALLENGE_LEADERBOARD_RANKING)
  },

  clearChallenges(context) {
    context.commit(types.CLEAR_CHALLENGES)
  },

  getChallenge: async function(context, payload) {
    const response = await api.challenge.getById(
      payload.organizationId,
      payload.challengeId
    )

    const site = await api.site.getById(
      payload.organizationId,
      response.data.sites[0]._id
    )
    response.data.sites[0] = site.data
    const challenge = { ...response.data, entityType: 'challenge' }
    context.commit(types.SET_CHALLENGE, {
      challenge: challenge,
    })
    return challenge
  },

  getChallengeRevs(context, payload) {
    const params = {}
    if (payload.page) params.page = payload.page
    if (payload.limit) params.limit = payload.limit

    return api.challenge
      .getRevs(payload.organizationId, payload.challengeid, params)
      .then(response => {
        const data = response.data
        context.commit(types.CLEAR_CHALLENGE_REVS)
        context.commit(types.SET_CHALLENGE_REVS, {
          revs: data.results,
        })

        context.dispatch('hideLoader')

        return data
      })
  },

  async getChallenges(context, payload) {
    const { filters = {}, terms } = payload
    const hasTerms = Boolean(terms)
    const callerFilters = _.omit(filters, [
      'organization',
      'site',
      'sites',
      'status',
    ])
    const status = _.isEmpty(filters.status)
      ? undefined
      : _.castArray(filters.status)
    const sites = _.isEmpty(filters.site)
      ? filters.sites
      : _.castArray(filters.site)

    const { data } = await api.explore.getContent({
      organizationId: payload.organizationId,
      terms,
      limit: payload.limit,
      from: payload.from,
      filters: {
        types: [constants.exploreEntityTypes.challenge],
        ...callerFilters,
        status,
        sites,
      },
      sort: hasTerms
        ? { by: '_score', order: 'desc' }
        : payload?.sort ?? { by: 'updatedTimestamp', order: 'desc' },
      projections: payload.projections,
      expansions: payload.expansions,
    })

    const challenges = data.results.map(result => result.response)

    context.commit(types.SET_CHALLENGES, { challenges })
    context.commit(types.SET_TOTAL_CHALLENGES, data.totalRecordsInData)

    return { results: challenges, totalRecordsInData: data.totalRecordsInData }
  },

  createChallenge(context, payload) {
    const creationData = Object.assign({}, payload.challenge)

    return api.challenge
      .create(payload.organizationId, creationData)
      .then(response => {
        const { data } = response
        context.commit(types.SET_CHALLENGE, {
          challenge: data,
        })

        return data._id
      })
  },

  updateChallenge(context, payload) {
    context.dispatch('showLoader')
    return api.challenge
      .update(payload.organizationId, payload.challengeId, payload.data)
      .then(response => {
        context.dispatch('hideLoader')
        return response
      })
      .catch(err => {
        context.dispatch('hideLoader')
        throw err
      })
  },

  removeChallenge(context, payload) {
    return api.challenge
      .remove(payload.organizationId, payload.challengeId)
      .then(response => {
        const data = response.data

        if (data) {
          context.commit(types.SET_CHALLENGE, {
            challenge: data,
          })
        }

        context.dispatch('hideLoader')
        return data
      })
      .catch(err => {
        context.dispatch('hideLoader')
        throw err
      })
  },

  getChallengesFromRev: async function(
    context,
    { revType, organizationId, revId }
  ) {
    const challenges = await api.challenge.getChallengesFromRev(
      revType,
      organizationId,
      revId
    )
    // if the rev has a challenge linked
    // the API is going to always return an array with one item
    return challenges.data?.[0] ?? null
  },

  linkChallengeToRev(context, { organizationId, revType, revId, challengeId }) {
    return api.challenge.linkChallengeToRev(
      organizationId,
      revType,
      revId,
      challengeId
    )
  },

  removeChallengeFromRev(context, { organizationId, revType, revId }) {
    return api.challenge.removeChallengeFromRev(organizationId, revType, revId)
  },
}
